import { render, staticRenderFns } from "./CommentRadio.vue?vue&type=template&id=37f3a12a&scoped=true&"
import script from "./CommentRadio.vue?vue&type=script&lang=js&"
export * from "./CommentRadio.vue?vue&type=script&lang=js&"
import style0 from "./CommentRadio.vue?vue&type=style&index=0&id=37f3a12a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f3a12a",
  null
  
)

export default component.exports